import { IPersonKeyParams, personKeys } from './personKeys';

export const paymentRemarkKeys = {
  root: (params: IPersonKeyParams) =>
    [...personKeys.root(params), 'payment-remark'] as const,
};

export function parsePaymentRemarkKey<T extends keyof typeof paymentRemarkKeys>(
  queryKey: ReturnType<(typeof paymentRemarkKeys)[T]>
) {
  const [, person] = queryKey;
  return { person };
}
